/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './team-group-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {TeamGroupApiService, TeamGroupModel} from './team-group-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-team-group-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamGroupListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.team-groups.team-group';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'type'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<TeamGroupModel>(
    inject(TeamGroupApiService),
    {listId: 'fullTeamGroupList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
